import { useSelector } from 'react-redux'
import DotsLoading from 'common-components/DotsLoading'
import AIHistoryItem from 'components/AIHistoryItem'
import { COLORS } from 'consts/colors'
import { IAIImageProject } from 'store/types/aiImage'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import AiImageHistoryTabItemImage from './Image'
import { reconstructAiImageHistoryItemData } from './utils'

interface IProps {
  items: IAIImageProject[]
}

export const AiImageHistoryTabContent: React.FC<IProps> = ({ items }) => {
  const isMoreDataLoading = useSelector(aiImageSelectors.isHistoryLoading)
  const modelsData = useSelector(aiImageSelectors.modelsData)

  return (
    <>
      {items.map(item => {
        const { tags, prompt, id } = reconstructAiImageHistoryItemData(
          item,
          modelsData
        )

        return (
          <AIHistoryItem
            key={id}
            prompt={prompt}
            tags={tags}
            content={<AiImageHistoryTabItemImage item={item} />}
          />
        )
      })}
      {isMoreDataLoading && (
        <DotsLoading dotColor={COLORS.primaryDark} size="xSmall" />
      )}
    </>
  )
}
